// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AccessoiresRouteImport } from './routes/accessoires'
import { Route as BeachwearRouteImport } from './routes/beachwear'
import { Route as CommandeConfirmeeRouteImport } from './routes/commande-confirmee'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as EchangesRetoursRouteImport } from './routes/echanges-retours'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as GuideDesTaillesRouteImport } from './routes/guide-des-tailles'
import { Route as KimonosRouteImport } from './routes/kimonos'
import { Route as LivraisonRouteImport } from './routes/livraison'
import { Route as MaillotsRouteImport } from './routes/maillots'
import { Route as NouveautesRouteImport } from './routes/nouveautes'
import { Route as PanierRouteImport } from './routes/panier'
import { Route as SacsRouteImport } from './routes/sacs'
import { Route as ProduitSlugRouteImport } from './routes/produit.$slug'
import { Route as SuiviOrderNumberRouteImport } from './routes/suivi.$orderNumber'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AccessoiresRoute = AccessoiresRouteImport.update({
            id: '/accessoires',path: '/accessoires',getParentRoute: () => rootRouteImport
          })
const BeachwearRoute = BeachwearRouteImport.update({
            id: '/beachwear',path: '/beachwear',getParentRoute: () => rootRouteImport
          })
const CommandeConfirmeeRoute = CommandeConfirmeeRouteImport.update({
            id: '/commande-confirmee',path: '/commande-confirmee',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const EchangesRetoursRoute = EchangesRetoursRouteImport.update({
            id: '/echanges-retours',path: '/echanges-retours',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const GuideDesTaillesRoute = GuideDesTaillesRouteImport.update({
            id: '/guide-des-tailles',path: '/guide-des-tailles',getParentRoute: () => rootRouteImport
          })
const KimonosRoute = KimonosRouteImport.update({
            id: '/kimonos',path: '/kimonos',getParentRoute: () => rootRouteImport
          })
const LivraisonRoute = LivraisonRouteImport.update({
            id: '/livraison',path: '/livraison',getParentRoute: () => rootRouteImport
          })
const MaillotsRoute = MaillotsRouteImport.update({
            id: '/maillots',path: '/maillots',getParentRoute: () => rootRouteImport
          })
const NouveautesRoute = NouveautesRouteImport.update({
            id: '/nouveautes',path: '/nouveautes',getParentRoute: () => rootRouteImport
          })
const PanierRoute = PanierRouteImport.update({
            id: '/panier',path: '/panier',getParentRoute: () => rootRouteImport
          })
const SacsRoute = SacsRouteImport.update({
            id: '/sacs',path: '/sacs',getParentRoute: () => rootRouteImport
          })
const ProduitSlugRoute = ProduitSlugRouteImport.update({
            id: '/produit/$slug',path: '/produit/$slug',getParentRoute: () => rootRouteImport
          })
const SuiviOrderNumberRoute = SuiviOrderNumberRouteImport.update({
            id: '/suivi/$orderNumber',path: '/suivi/$orderNumber',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AccessoiresRoute: AccessoiresRoute,BeachwearRoute: BeachwearRoute,CommandeConfirmeeRoute: CommandeConfirmeeRoute,ContactRoute: ContactRoute,EchangesRetoursRoute: EchangesRetoursRoute,FaqRoute: FaqRoute,GuideDesTaillesRoute: GuideDesTaillesRoute,KimonosRoute: KimonosRoute,LivraisonRoute: LivraisonRoute,MaillotsRoute: MaillotsRoute,NouveautesRoute: NouveautesRoute,PanierRoute: PanierRoute,SacsRoute: SacsRoute,ProduitSlugRoute: ProduitSlugRoute,SuiviOrderNumberRoute: SuiviOrderNumberRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)